import "@/App.css";
import { useEffect, useState } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { FormContextProvider } from "@/components/context/useFormContext";
import {
	ALL_LOAN_TYPES,
	LOAN_TYPE_BOAT,
	LOAN_TYPE_CAR,
	LOAN_TYPE_CARAVAN,
	LOAN_TYPE_EQUIPMENT,
	LOAN_TYPE_PERSONAL,
	LOAN_TYPE_TRUCK,
} from "@/lib/constants";
import { QuickFormMain } from "@/components/forms/quickFormMain";

const queryClient = new QueryClient();

type AppProps = {
	rootElement: HTMLElement;
};

export default function App({ rootElement }: AppProps) {
	const [component, setComponent] = useState<string | undefined>(undefined);
	const [siteTitle, setSiteTitle] = useState<string | undefined>(undefined);
	const [loan, setLoan] = useState<string | undefined>(undefined);

	useEffect(() => {
		const container = rootElement?.dataset.component;
		const siteTitle = rootElement?.dataset.title;

		switch (container) {
			case "main":
				setLoan(ALL_LOAN_TYPES);
				break;
			case "car":
				setLoan(LOAN_TYPE_CAR);
				break;
			case "boat":
				setLoan(LOAN_TYPE_BOAT);
				break;
			case "caravan":
				setLoan(LOAN_TYPE_CARAVAN);
				break;
			case "truck":
				setLoan(LOAN_TYPE_TRUCK);
				break;
			case "equipment":
				setLoan(LOAN_TYPE_EQUIPMENT);
				break;
			case "personal":
				setLoan(LOAN_TYPE_PERSONAL);
				break;
			default:
				setLoan(LOAN_TYPE_PERSONAL);
				break;
		}

		setSiteTitle(siteTitle);
		setComponent(container);
	}, [rootElement, siteTitle, loan]);

	const renderComponent = () => {
		return (
			<QuickFormMain
				rootId={rootElement}
				loanTypes={loan}
				siteTitle={siteTitle}
			/>
		);
	};

	return (
		<FormContextProvider id={rootElement}>
			<QueryClientProvider client={queryClient}>
				{siteTitle ? renderComponent() : <div>Loading...</div>}
			</QueryClientProvider>
		</FormContextProvider>
	);
}
